import React, { useEffect, useState } from "react";
import { useAppServices } from "hook/services";
import { useAgencyInfo } from "context/agency";
import SoftBox from "components/SoftBox";
import SoftButton from "components/SoftButton";
import GoogleReviews from "./Component/GoogleReviews";
import "./accountDetailTabs.css";

function Reviews({ formData, handleRefresh }) {
  const AppService = useAppServices();
  const [agency] = useAgencyInfo();
  const [success, setSuccess] = useState("");
  const [reviews, setReviews] = useState([]);
  const [googlereviews, setGoogleReviews] = useState([]);
  const [expandedReviews, setExpandedReviews] = useState({}); // track expanded reviews

  // fetch app reviews
  useEffect(() => {
    if (formData !== undefined) {
      const getReviews = async () => {
        const { response } = await AppService.reviews.get({
          query: `business_id=${formData._id}&status=approved`,
        });
        if (response) {
          setReviews(response.data);
        }
      };
      getReviews();
    }
  }, [formData]);

  // fetch google reviews
  useEffect(() => {
    if (formData !== undefined) {
      const getReviewsGoogle = async () => {
        const { response } = await AppService.reviews.GetFromGoogle({
          query: `place_id=${formData.google_place_id}&apiKey=${agency?.google_image_api_key}`,
        });
        if (response) {
          setGoogleReviews(response.data?.reviews || []);
        }
      };
      getReviewsGoogle();
    }
  }, [formData]);

  // toggle read more
  const toggleExpand = (id) => {
    setExpandedReviews((prev) => ({
      ...prev,
      [id]: !prev[id],
    }));
  };

  const renderContent = (id, text) => {
    const isExpanded = expandedReviews[id];
    if (!text) return null;
    if (text.length <= 150) return text;

    return (
      <>
        {isExpanded ? text : text.slice(0, 150) + "... "}
        <div
          onClick={() => toggleExpand(id)}
          className="underline text-sm"
          style={{color:"blue",cursor:"pointer"}}
        >
          {isExpanded ? "Read Less" : "Read More"}
        </div>
      </>
    );
  };

  return (
    <div className="sd-account-detail-tab">
      <p className="text-center">{success}</p>
      <SoftBox>
        <div className="overflow-x-auto mt-10">
          <table style={{ width: "100%", borderCollapse: "collapse" }}>
            <thead>
              <tr>
                <th className="text-left">Name</th>
                <th className="text-left">Content</th>
                <th className="text-left">Rating</th>
              </tr>
            </thead>
            <tbody>
              {(!formData?.google_place_id ||
              ((reviews?.length ?? 0) === 0 &&
                (googlereviews?.length ?? 0) === 0)) ? (
                <tr>
                  <td colSpan={3} className="text-center py-4">
                    {formData?.google_place_id
                      ? "No reviews found"
                      : "Please Add Link to Google Business Profile In Business Detail"}
                  </td>
                </tr>
              ) : (
                <>
                  {reviews?.map((review) => (
                    <tr key={review._id}>
                      <td>{review?.user_id?.business_name}</td>
                      <td>{renderContent(review._id, review.content)}</td>
                      <td>
                        {Array.from({ length: 5 }).map((_, i) => (
                          <span
                            key={i}
                            style={{
                              color: i < review.rating ? "#FFD700" : "#ccc",
                              fontSize: "16px",
                            }}
                          >
                            {i < review.rating ? "★" : "☆"}
                          </span>
                        ))}
                      </td>
                    </tr>
                  ))}

                  {googlereviews?.map((review, index) => (
                    <tr key={review?.time || index}>
                      <td>{review?.author_name}</td>
                      <td>{renderContent(review?.time || index, review.text)}</td>
                      <td>
                        {Array.from({ length: 5 }).map((_, i) => (
                          <span
                            key={i}
                            style={{
                              color: i < review.rating ? "#FFD700" : "#ccc",
                              fontSize: "16px",
                            }}
                          >
                            {i < review.rating ? "★" : "☆"}
                          </span>
                        ))}
                      </td>
                    </tr>
                  ))}
                </>
              )}
            </tbody>
          </table>
        </div>
      </SoftBox>
    </div>
  );
}

export default Reviews;
